import { render, staticRenderFns } from "./tasks.vue?vue&type=template&id=669802d5&scoped=true"
import script from "./tasks.vue?vue&type=script&lang=js"
export * from "./tasks.vue?vue&type=script&lang=js"
import style0 from "./tasks.vue?vue&type=style&index=0&id=669802d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669802d5",
  null
  
)

export default component.exports